// Campus photo for /colleges/northeastern-university: CC BY 4.0, by ajay_suresh, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AEll_Hall_-_Northeastern_University_(54953357542).jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/northeastern-university/; credited under the photo.
const photo = {
    "slug": "northeastern-university",
    "alt": "Ell Hall behind a lawn on the Boston campus of Northeastern University in Boston, Massachusetts",
    "src": "/colleges/northeastern-university/campus-1600.webp",
    "srcSmall": "/colleges/northeastern-university/campus-800.webp",
    "srcMid": "/colleges/northeastern-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/northeastern-university/og.jpg",
    "title": "Ell Hall - Northeastern University (54953357542)",
    "author": "ajay_suresh",
    "license": "CC BY 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AEll_Hall_-_Northeastern_University_(54953357542).jpg",
    "read": "2026-10-01"
};

export default photo;
